var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2521_9511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3566 28.9154L38.8043 28.9141C37.5435 28.9141 36.5215 29.9359 36.5215 31.1967V40.3179C36.5215 41.5785 37.5435 42.6006 38.8041 42.6006H54.8831C53.1224 47.1698 49.8362 50.9965 45.6436 53.4279L52.4997 65.2963C63.4976 58.9357 69.9997 47.7755 69.9997 35.2824C69.9997 33.5036 69.8685 32.232 69.6063 30.8001C69.407 29.7122 68.4625 28.9154 67.3566 28.9154Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 56.3038C27.1317 56.3038 20.2624 52.0045 16.5731 45.6426L4.70508 52.4832C10.7446 62.9506 22.0587 69.9994 35.0005 69.9994C41.3493 69.9994 47.3399 68.29 52.5004 65.3111V65.2948L45.6444 53.4263C42.5084 55.2452 38.8793 56.3038 35.0005 56.3038Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 65.3126V65.2963L45.644 53.4277C42.5079 55.2465 38.8791 56.3053 35 56.3053V70.0009C41.3488 70.0009 47.3397 68.2915 52.5 65.3126Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6957 34.9994C13.6957 31.1208 14.7541 27.4921 16.5726 24.3562L4.70463 17.5156C1.70926 22.6599 0 28.6343 0 34.9994C0 41.3644 1.70926 47.3388 4.70463 52.4831L16.5726 45.6425C14.7541 42.5066 13.6957 38.8779 13.6957 34.9994Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 13.6957C40.1316 13.6957 44.8449 15.5189 48.5263 18.5518C49.4345 19.2999 50.7546 19.2459 51.5865 18.414L58.0492 11.9513C58.9931 11.0074 58.9258 9.46231 57.9175 8.58758C51.7495 3.23654 43.7241 0 35.0005 0C22.0587 0 10.7446 7.04881 4.70508 17.5163L16.5731 24.3569C20.2624 17.9949 27.1317 13.6957 35.0005 13.6957Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5259 18.5518C49.4341 19.2999 50.7542 19.2459 51.586 18.414L58.0487 11.9513C58.9925 11.0074 58.9252 9.46231 57.9171 8.58758C51.749 3.23641 43.7236 0 35 0V13.6957C40.1311 13.6957 44.8444 15.5189 48.5259 18.5518Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2521_9511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.5a8df05b5eb8289979ccc7f90802e2bf.svg";
export { ForwardRef as ReactComponent };